import React from 'react'
import createReactClass from 'create-react-class'
import {assoc} from 'ramda'
import GupsMixin from 'legacy_support/GupsMixin'
import Leaf from 'components/ui/icons/ios/Leaf'

/* eslint-disable jsx-a11y/anchor-is-valid */

const HabitBannerComponent = createReactClass({
  displayName: 'HabitBannerComponent',

  mixins: [GupsMixin],

  getDataMap() {
    return {
      settings: ['people', gf.app.currentPersonId(), 'settings'],
    }
  },

  banner_state() {
    return !this.state.settings.habit_banner_1_hidden_at ? 1 : 2
  },

  hideBanner() {
    const timeStamp = Math.floor(Date.now() / 1000)
    const newSettings = assoc(`habit_banner_${this.banner_state()}_hidden_at`, timeStamp, this.state.settings)
    this.setState({bannerDismissed: true})
    this.toggleBanner(newSettings)
  },

  toggleBanner(settings) {
    return this.dispatch({
      type: 'DEFAULT_UPDATE',
      resourceType: 'people',
      resourceId: gf.app.currentPersonId(),
      data: {
        settings,
      },
    })
  },

  render() {
    if (!this.state.settings || this.state.bannerDismissed)
      return null

    return (
      <div className="banner banner-habit">
        <div className="banner__content">
          <span className="banner__content-caption test-banner-content">
            <span className="banner__content-caption-icon">
              <Leaf />
            </span>
            <span className="banner__content-caption-text">
              {I18n.t(
                `holacracy_help.holacracy_habits.banner_notice${
                  this.banner_state() === 2 ? '_2' : ''
                }`,
              )}
            </span>
          </span>
          <span>
            <a href="/lessons" className="banner__content-cta pe-4">
              {I18n.t('holacracy_help.holacracy_habits.banner_notice_yes')}
            </a>
            <a
              href="#"
              onClick={this.hideBanner}
              className="banner-second-link test-habit-banner-dismiss"
            >
              {I18n.t('holacracy_help.holacracy_habits.banner_notice_no')}
            </a>
          </span>
        </div>
      </div>
    )
  },
})

export default HabitBannerComponent
